// extracted by mini-css-extract-plugin
export var active = "_r2-1";
export var circle = "_r2-0";
export var completed = "_r2-2";
export var connector = "_r2-4";
export var connectorCompleted = "_r2-7";
export var connectorSpacer = "_r2-5";
export var iconStrokeOverride = "_r2-8";
export var labelContainer = "_r2-6";
export var pending = "_r2-3";